import React from 'react'


function Awards() {
    return (
        <div className='container'>
            <div className='row'>
                <div className='col-6 p-5'>
                    <img src='media/largestBroker.svg' />
                </div>
                <div className='col-6  p-5 mt-5'>
                    <h2> Largest stosk broker in India</h2>
                    <p className='mb-5'>2+ million Zerodha clients contribute to over 15% of all retail order <br></br> volumes in India daily by trading and investing in:</p>
                    <div className='row'>
                        <div className='col-6'>
                            <ul>
                                <li>
                                    <p>Futures and Options</p>
                                </li>
                                <li>
                                    <p>Commodity derivatives</p>
                                </li>
                                <li>
                                    <p>Currency derivatives</p>
                                </li>
                            </ul>
                        </div>
                        <div className='col-6'>
                            <ul>
                                <li>
                                    <p>Stoks & IPOs</p>
                                </li>
                                <li>
                                    <p>Direct mutual funds</p>
                                </li>
                                <li>
                                    <p>Bonds and Grow and Securities</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <img src='media/pressLogos.png' style={{ width: "90%" }} alt='presslogo' />
                </div>
            </div>
        </div>
    );
}

export default Awards;